export default __webpack_public_path__ + "static/media/icon_value_introduction.3ababca1.svg";